import { render, staticRenderFns } from "./bbgl-qc-ds.vue?vue&type=template&id=3b72bea5&scoped=true"
import script from "./bbgl-qc-ds.vue?vue&type=script&lang=js"
export * from "./bbgl-qc-ds.vue?vue&type=script&lang=js"
import style0 from "./bbgl-qc-ds.vue?vue&type=style&index=0&id=3b72bea5&prod&lang=scss"
import style1 from "./bbgl-qc-ds.vue?vue&type=style&index=1&id=3b72bea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72bea5",
  null
  
)

export default component.exports